"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/prefer-default-export
var DVBThreeStepsInitStates;
(function (DVBThreeStepsInitStates) {
    DVBThreeStepsInitStates[DVBThreeStepsInitStates["ready"] = 0] = "ready";
    DVBThreeStepsInitStates[DVBThreeStepsInitStates["initiating"] = 1] = "initiating";
    DVBThreeStepsInitStates[DVBThreeStepsInitStates["ok"] = 2] = "ok";
    DVBThreeStepsInitStates[DVBThreeStepsInitStates["failed"] = -2] = "failed";
})(DVBThreeStepsInitStates = exports.DVBThreeStepsInitStates || (exports.DVBThreeStepsInitStates = {}));
//# sourceMappingURL=DVBThreeStepsInitStates.js.map